import { SiteStoreState } from './site-store.types';

// ? Intended for future use
export const STORE_NAME: string = 'SITE';

export const initialState: SiteStoreState = {
  sites: [],
};
